import * as React from 'react';
import { Box, Card, CardContent, CardHeader, Chip, Grid } from '@material-ui/core';
import { CaseAttachment, FnolDamagePartDto } from '../../../../interfaces/Case';
import CaseAttachmentCard from '../../../_shared/CaseAttachmentCard';
import DamageReferentialLabel from '../../../_shared/DamageReferentialLabel';
import { DistanceTypeCode } from '../../../../helpers/Constants';

export interface DamagePartCardProps {
  part: FnolDamagePartDto;
  showMarkers?: boolean;
}

const distanceTypeBadge = (photo: CaseAttachment) => (
  <Chip
    size="small"
    color={photo.distanceType?.code === DistanceTypeCode.FAR ? 'primary' : 'secondary'}
    label={photo.distanceType?.displayName}
  />
);

const DamagePartCard: React.FC<DamagePartCardProps> = ({ part, showMarkers = true }) => (
  <Card elevation={0}>
    <Box bgcolor="grey.100">
      <CardHeader
        title={part.cupiCode ? `${part.gtPart?.displayName} (${part.cupiCode})` : part.gtPart?.displayName}
        subheader={
          <Box display="flex" flexWrap="wrap" mt={1} style={{ gap: 16 }}>
            {part.damageType ? (
              <DamageReferentialLabel
                displayName={part.damageType.displayName}
                displayDescription={part.damageType.displayDescription}
              />
            ) : null}
            {part.damageSeverity ? (
              <DamageReferentialLabel
                displayName={part.damageSeverity.displayName}
                displayDescription={part.damageSeverity.displayDescription}
                level={part.damageSeverity.level}
              />
            ) : null}
          </Box>
        }
        action={
          <Box display="flex" style={{ gap: 8 }}>
            {part.operation ? <Chip size="small" color="primary" label={part.operation.displayName} /> : null}
            {part.time != null ? <Chip size="small" variant="outlined" label={`${part.time} h`} /> : null}
          </Box>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          {part.photos.map((photo) => (
            <Grid item container xs={12} md={6} key={photo.id}>
              <CaseAttachmentCard
                caseId={part.caseId}
                attachmentType={null}
                attachments={[photo]}
                hasRights={false}
                isMultiple={false}
                isSelectionGroup={false}
                allowOnlyImages={true}
                addWatermark={false}
                showUploadMessage={false}
                downloadModelFile={false}
                viewHiddenServiceDocuments={false}
                organizationName=""
                organizationCity=""
                onAttachmentsChanged={() => undefined}
                headerAction={distanceTypeBadge(photo)}
                isDamagePhoto={true}
                damageMarkerLabel={part.damageType?.displayName}
                showDamageMarker={showMarkers}
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Box>
  </Card>
);

export default DamagePartCard;
